<template>
	<div class="block_inp p-3">
		<div class="form-group mt-2">
			<label class="form-label" for="advanced_name">
				Назва питання
			</label>

			<div class="input-group flex-nowrap">
				<div class="input-group-prepend">
							<span class="input-group-text">
								<i class="fal  fa-typewriter fs-xl" ></i>
							</span>
				</div>
				<input id="advanced_name" type="text" class="form-control" v-model="question.title">
			</div>
		</div>

		<div class="row">
			<div class="col-4 col-lg-4 col-sm-4 col-md-4">
				<div class="form-group mt-2">
					<label class="form-label" for="advanced_name">
						Тип питання
					</label>

					<div class="input-group flex-nowrap">
						<b-form-radio-group
							id="btn-radios-1"
							v-model="question.type"
							button-variant="outline-primary"
							:options="[
												  { text: 'При вїзді', value: 'in' },
												  { text: 'При виїзді', value: 'out' }]"
							name="radios-btn-default"
							buttons
						></b-form-radio-group>
					</div>
				</div>
			</div>

			<div class="col-4 col-lg-4 col-sm-4 col-md-4">
				<div class="form-group mt-2">
					<label class="form-label" for="advanced_name">
						ТМЦ тип
					</label>

					<div class="input-group flex-nowrap">
						<b-form-radio-group
							id="btn-radios-1"
							v-model="question.tmz_type"
							button-variant="outline-primary"
							:options="[
												  { text: 'Завоз ТМЦ', value: 'in_tmz' },
												  { text: 'Вивоз  ТМЦ', value: 'out_tmz' }]"
							name="radios-btn-default"
							buttons
						></b-form-radio-group>
					</div>
				</div>
			</div>

			<div class="col-4 col-lg-4 col-sm-4 col-md-4">
				<div class="form-group mt-2">
					<label class="form-label" for="advanced_name">
						UPROX validate
					</label>

					<div class="input-group flex-nowrap">
						<b-form-radio-group
							id="btn-radios-1"
							v-model="question.uprox_check"
							button-variant="outline-primary"
							:options="[
												  { text: 'Так', value: '1' },
												  { text: 'Ні', value: '0' }]"
							name="radios-btn-default"
							buttons
						></b-form-radio-group>
					</div>
				</div>
			</div>


			<!--
			<div class="col-4 col-lg-4 col-sm-4 col-md-4">
				<div class="form-group mt-2">
					<label class="form-label" for="advanced_name">
						Власник
					</label>

					<div class="input-group flex-nowrap">
						<b-form-radio-group
							id="btn-radios-1"
							v-model="question.owner_type"
							button-variant="outline-primary"
							:options="[
												  { text: 'ІМК', value: 'own' },
												  { text: 'Треті особи', value: '3rd' }]"
							name="radios-btn-default"
							buttons
						></b-form-radio-group>
					</div>
				</div>
			</div>
			-->
		</div>


		<div class="form-group mt-4">
			<label class="form-label" >
				Привязка до типу ОС
			</label>

			<div class="" v-if="types.length > 0">
				<v-select
					multiple
					v-model="active_type"
					class="imc_reasons"
					label="name"
					:options="this.types"
					:filterable="false"
				>
					<template slot="no-options">
						Оберіть Тип(и)
					</template>

					<template slot="option"  slot-scope="option">
						<div class="d-center">
							{{ option.name }}
						</div>
					</template>
				</v-select>
			</div>
		</div>


	</div>


</template>

<script>
import vSelect from 'vue-select'
export default {
	name: "checklist_info",

	props : {
		question : {
			type : Object
		}
	},
	components : {
		vSelect
	},
	data () {
		return {
			types : [],
			is_load : false,
		}
	},
	created() {
		this.load_os_tips();
	},

	methods : {
        //+
		async load_os_tips()  {
			this.types = []
				await api.get('/nfc/os_types').then(({data}) => {
				if (data.status == "operation_success") {
					this.types = data.data;
				}
			}).catch(err => {
				EventBus.$emit('show_toast', {err: err.message, type: "danger", title: err.name})
			});
		}
	},

	computed : {
		active_type : {
			get :  function() {
				if(this.question.hasOwnProperty("tips_ids")) {
					return this.question.tips_ids;
				}

				return [];
			},

			set : function(val) {
				this.question.tips_ids = val;
			}
		},

	}



}
</script>

<style scoped>

</style>
